// MF-67 — Shared look for the Journal insight charts (ECharts). Series are the tenant's TYPES
// (their own label, colour and order). The seeded defaults use the CVD-validated pair (aqua / orange:
// deutan ΔE 9.2); schools may recolour, so every chart also carries direct labels + a legend (identity
// is never colour-alone).
import { TYPE_FALLBACK_COLORS } from '../components/colorTokens'

const cap = (s) =>
  String(s || '')
    .charAt(0)
    .toUpperCase() + String(s || '').slice(1)

// { label, color } for a type code, from the tenant's types map (with fallbacks).
export const typeStyle = (code, byCode) => {
  const s = byCode?.get(code)
  return {
    label: s?.label || cap(code),
    color: s?.color || TYPE_FALLBACK_COLORS[code] || TYPE_FALLBACK_COLORS.neutral
  }
}

// Type codes in the tenant's configured order, then any unknown codes present in the data.
export const orderedTypes = (codesInData, list = []) => {
  const known = list.map((s) => s.code)
  return [...known.filter((c) => codesInData.includes(c)), ...codesInData.filter((c) => !known.includes(c))]
}

export const INK = {
  primary: 'rgb(15, 23, 42)',
  secondary: 'rgb(100, 116, 139)',
  muted: 'rgb(148, 163, 184)',
  grid: 'rgb(241, 245, 249)',
  axis: 'rgb(226, 232, 240)',
  surface: '#ffffff'
}

export const FONT = 'Poppins, Arial, sans-serif'

export const baseTextStyle = { fontFamily: FONT, color: INK.secondary, fontSize: 11 }

export const tooltipBase = {
  backgroundColor: '#fff',
  borderColor: INK.axis,
  borderWidth: 1,
  padding: [8, 12],
  textStyle: { fontFamily: FONT, color: INK.primary, fontSize: 12 },
  extraCssText: 'box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12); border-radius: 8px;'
}

export const legendBase = {
  top: 0,
  left: 0,
  icon: 'roundRect',
  itemWidth: 12,
  itemHeight: 4,
  itemGap: 16,
  textStyle: { fontFamily: FONT, color: INK.secondary, fontSize: 12 }
}

export const fmtNumber = (n) => (Number(n) || 0).toLocaleString()
export const fmtPct = (part, whole) => (whole ? `${Math.round((part / whole) * 1000) / 10}%` : '0%')
